<template>
    <div class="relative">
        <div class="absolute w-full h-full flex justify-center items-center z-10">
            <slot />
        </div>
        <svg
            class="w-full h-full"
            :class="[color.mediumText]"
            fill="currentColor"
            viewBox="0 0 141.297 141.297"
            xmlns="http://www.w3.org/2000/svg"
            :style="style"
        >
            <circle cx="70.5" cy="70.5" r="70" v-if="shape === 'circle'" />
            <path
                v-if="shape === 'pentagon'"
                style="stroke-width: 0.276087"
                d="M57.55 189.423c-4.193-.908-8.184-3.946-10.036-7.639-1.068-2.129-21.968-65.988-22.687-69.32-.508-2.353-.506-3.675.01-6.125a14.477 14.477 0 0 1 3.827-7.2c1.155-1.196 10.418-8.084 29.163-21.687 15.11-10.965 28.216-20.403 29.127-20.973 4.608-2.886 10.192-3.156 15.02-.726 2.44 1.228 57.126 40.948 59.303 43.074 2.025 1.976 3.494 4.678 4.087 7.512.504 2.414.507 3.651.016 5.972-.597 2.817-21.587 67.226-22.57 69.262-1.838 3.8-5.982 6.948-10.371 7.878-2.746.582-72.191.556-74.888-.028z"
                transform="translate(-24.448 -51.341)"
            />
        </svg>
        <div class="absolute right-0 bottom-0 w-8 h-8 z-20" v-if="isCompleted">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-full h-full text-lime-400 rounded-full icon icon-tabler icon-tabler-circle-check"
                viewBox="0 0 24 24"
                stroke-width="2.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M9 12l2 2l4 -4"></path>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StationBase',
};
</script>
<script setup>
import { colors } from '@/TailwindColors.js';
import { computed } from 'vue';

const props = defineProps({
    color: {
        type: String,
    },
    shape: {
        type: String,
    },
    withShadow: {
        type: Boolean,
    },
    isCompleted: {
        type: Boolean,
    },
});

const style = {
    filter: props.withShadow ? 'drop-shadow(5px 31px 20px #aaaaaa)' : '',
};

const color = computed(() => {
    return colors.find((c) => c.name === props.color);
});
</script>
